import {EducationSection} from "@components";
import {withOpacityTransition} from "@hoc";

const Education = () => {
    return (
        <EducationSection/>
    )
}

export default withOpacityTransition(Education)
